import { FC } from "react";
import { Skeleton } from "@mui/material";
import { rounded } from "@/theme/variables";

export const RecommendationSkeleton: FC = () => {
  return (
    <Skeleton
      variant="rounded"
      height={100}
      sx={{ borderRadius: rounded.xs }}
    />
  );
};
